import { render, staticRenderFns } from "./LaboratoryIndicatorsBlock.vue?vue&type=template&id=5f70a6ae&lang=pug&"
import script from "./LaboratoryIndicatorsBlock.vue?vue&type=script&lang=js&"
export * from "./LaboratoryIndicatorsBlock.vue?vue&type=script&lang=js&"
import style0 from "./LaboratoryIndicatorsBlock.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports